<template>
    <div
        id="page-not-found"
        class="page-content"
        data-aos="fade-in"
        data-aos-duration="700"
        data-aos-easing="ease-in-out"
        data-aos-once="true"
    >
        <base-text type="h1">
            Oops, page not found.
        </base-text>
    </div>
</template>

<script>
    export default {
        name: 'page-not-found',
    };
</script>

<style lang="scss" scoped>
    #page-not-found {
        min-height: calc(100vh - #{$footer-height});
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
